var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-select',_vm._g({staticClass:"special-area-select-v1",attrs:{"options":_vm.options},on:{"change":_vm.change},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }